import React, { useEffect, useMemo, useState } from 'react'
import '../../../Assets/Css/EmployeeSalarySlip.scss';
import Table from "../../../Components/Table";
import BankRedIcon from '../../../Assets/Images/Employee/Bank Red.svg';
import BankGreenIcon from '../../../Assets/Images/Employee/Bank Green.svg';
import SalaryDetailRedIcon from '../../../Assets/Images/Employee/Salary Detail Red.svg';
import SalaryDetailGreenIcon from '../../../Assets/Images/Employee/Salary Detail Green.svg';
import { GoEye } from "react-icons/go";
import { Modal, Spinner } from 'react-bootstrap';
import OpenEye from '../../../Assets/Images/Employee/OpenEye.svg'
import CloseEye from '../../../Assets/Images/Employee/CloseEye.svg'
import { connect } from 'react-redux';
import { addBankdetails, getBankdetails, updateBankdetails } from '../../../Services/Bankdetails/action';
import { api } from '../../../Lib/constants';
import { getAuthHeader, Year } from '../../../Lib/utils';
import Select from 'react-select';
import { customStyle } from '../../../Components/Style';
import { getUsers } from '../../../Services/Users/action';
import { toast } from 'react-toastify';
import { getSalaryDetails, updateSalarySlip } from '../../../Services/Salary/action';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../../Assets/ModulesLiist';
import FeaturesList from '../../../Assets/FeaturesList';
import { Month } from '../../../Lib/utils';
import UserAvatar from 'react-user-avatar';
import { Avatar } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

const EmpSalarySlips = (props) => {
    const [inData, setInData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showSalary, setShowSalary] = useState(true);
    const [bankDetails, setBankDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSalaryModal, setShowSalaryModal] = useState(false);
    const [totalMonthPaid, setTotalMonthsPaid] = useState(0);
    const [totalEarnings, setTotalEarnings] = useState(0);
    const [salaryAmount, setSalaryAmount] = useState('');
    const [currentCTC, setCurrenctCTC] = useState('');
    const [salarySlipData, setSalarySlipData] = useState([]);
    const userProfilePic = localStorage.getItem('userProfilePic');
    const [selectedMonth, setSelectedMonth] = useState();
    const [selectedYear, setSelectedYear] = useState();
    const navigate = useNavigate();
    const location = useLocation()

    const canEdit = checkFeatureAccess({
        modules: props?.modules,
        features: props?.features,
        user: props?.user,
        ModuleName: ModulesList.Salary,
        Featur_Name: FeaturesList.Update,
    });

    useEffect(() => {
        props?.getBankdetails();
        props?.getUsers({ module: 'salary' });
        props?.getSalaryDetails();
    }, [])

    const header = [
        { field: "Name" },
        { field: "Transaction ID" },
        { field: "Pay Period" },
        { field: "Pay Date" },
        { field: "Amount" },
        { field: "Action" },
    ];

    const Employee = props?.users?.map(item => {
        return {
            value: item?.id,
            label: item?.name
        }
    })

    useEffect(() => {
        if (props?.bankdetails) {
            const filteredBankDetails = props?.bankdetails?.filter(item => item?.user_id == props?.user?.id);
            setBankDetails(filteredBankDetails);
            setBankName(filteredBankDetails[0]?.bank_name || '');
            setAccountNumber(filteredBankDetails[0]?.account_number || '');
            setIfscCode(filteredBankDetails[0]?.ifsc_code || '');
            setBranchName(filteredBankDetails[0]?.branch_name || '');
            setAccountHolderName(filteredBankDetails[0]?.acc_holder_name || '');
        }
    }, [props?.bankdetails])

    const MissingBankDetails = !bankDetails?.length;
    let footer = true;
    let count = inData?.length;

    const [bank_name, setBankName] = useState('');
    const [account_number, setAccountNumber] = useState('');
    const [ifsc_code, setIfscCode] = useState('');
    const [branch_name, setBranchName] = useState('');
    const [acc_holder_name, setAccountHolderName] = useState('');


    useEffect(() => {
        if (props?.salary && Array.isArray(props?.salary)) {

            setSalarySlipData(props?.salary);


            const currentUserId = props?.user?.id;
            const filteredData = props?.user?.id === 1 || props?.user?.role === 'hr'
                ? props?.salary
                : props?.salary.filter((item) => {
                    const itemEmployeeId = String(item?.employee_id);
                    const currentUserIdStr = String(currentUserId);
                    return itemEmployeeId === currentUserIdStr;
                });

            const timeFilter = filteredData.filter((item) => {
                const payPeriodDate = new Date(item?.pay_period);
                const itemMonth = payPeriodDate.toLocaleString('default', { month: 'long' });
                console.log(itemMonth)
                const itemYear = payPeriodDate.getFullYear();

                const isMonthMatch = selectedMonth?.value ? itemMonth === selectedMonth?.value : true;
                const isYearMatch = selectedYear?.value ? itemYear === Number(selectedYear.value) : true;

                return isMonthMatch && isYearMatch;
            });


            const tableData = timeFilter.map((item) => {

                const formatDate = (dateString) => {
                    if (!dateString) return '-';
                    try {
                        const date = new Date(dateString);
                        return date.toLocaleDateString('en-GB');
                    } catch (error) {
                        return dateString;
                    }
                };

                return {
                    "Name": {
                        value: item?.name,
                        type: "text",
                    },
                    "Transaction ID": {
                        value: item?.transaction_id || "-",
                        type: "text",
                    },
                    "Pay Period": {
                        value: item?.pay_period || "-",
                        type: "text"
                    },
                    "Pay Date": {
                        value: formatDate(item?.pay_date) || "-",
                        type: "text",
                    },
                    "Amount": {
                        value: `₹ ${item?.total_pay || '0.00'}`,
                        type: "salaryamount",
                    },
                    Action: {
                        type: "action",
                        value: "/salary/empsalary/salaryslips/edit",
                        value2: "/salary/empsalary/salaryslips/view"
                    },
                    allData: {
                        ...item
                    }
                };
            });

            setInData(tableData);
        } else {
            setInData([]);
            setSalarySlipData([]);
        }
    }, [props?.salary, props?.user?.id, location.pathname, selectedYear, selectedMonth]);

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const openSalarySlipModal = () => {
        navigate('/salary/empsalary/salaryslips/generateslip')
    };

    const closeSalarySlipModal = () => {
        setLoading(false);
    };

    const openSalaryModal = () => {
        setShowSalaryModal(true);
    };

    const closeSalaryModal = () => {
        setShowSalaryModal(false);
    };

    const changeVisibility = () => {
        setShowSalary((prevSalay) => !prevSalay);
    };

    const handleSave = async () => {
        try {
            const body = {
                user_id: props?.user?.id,
                bank_name,
                account_number,
                ifsc_code,
                branch_name,
                acc_holder_name,
            }
            if (bankDetails?.length > 0) {
                await props?.updateBankdetails(bankDetails?.[0]?.id, body);
            }
            else {
                await props?.addBankdetails(body);
            }
            closeModal();
        } catch (error) {
            console.error("Error adding bank details :", error)
        }
    }

    return (
        <>
            <div className="employeeSalary-main">
                <div className="main-division">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className=''>
                            <h5 className="">
                                {
                                    props.loading ? (
                                        <Skeleton className='rounded-2' width={200} height={40} />
                                    ) : (
                                        "Salary"
                                    )
                                }
                            </h5>
                        </div>
                        <div className='d-flex gap-3'>
                            <div>
                                {
                                    props.loading ? (
                                        <Skeleton className='rounded-2' width={150} height={40} />
                                    ) : (
                                        <Select
                                            styles={customStyle}
                                            placeholder="Select Month"
                                            value={selectedMonth}
                                            options={Month}
                                            onChange={(selectedOption) => setSelectedMonth(selectedOption)}
                                        />
                                    )
                                }
                            </div>
                            <div>
                                {
                                    props.loading ? (
                                        <Skeleton className='rounded-2' width={150} height={40} />
                                    ) : (
                                        <Select
                                            styles={customStyle}
                                            placeholder="Select Year"
                                            value={selectedYear}
                                            options={Year}
                                            onChange={(selectedOption) => setSelectedYear(selectedOption)}
                                        />
                                    )
                                }
                            </div>
                            <div className='' style={{
                                textAlign: 'right',
                                textWrap: 'nowrap',
                            }}>
                                {
                                    props.loading ? (
                                        <Skeleton className="badge rounded-pill" width={100} height={40} />
                                    ) : (
                                        <RoleWiseFeatureWrapper
                                            modules={props?.modules}
                                            features={props?.features}
                                            user={props?.user}
                                            ModuleName={ModulesList.Salary}
                                            Featur_Name={FeaturesList.GenerateSalarySlip}>

                                            <button
                                                className="export-btn"
                                                id="exportBtn"
                                                onClick={openSalarySlipModal}
                                            >
                                                Generate Salary Slip
                                            </button>
                                        </RoleWiseFeatureWrapper>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    <div className="invoice-table-part mt-5">
                        {
                            props.loading ? (
                                <Skeleton className='rounded-2' count={5} width="100%" height={40} />
                            ) : (
                                <Table
                                    header={header}
                                    data={inData}
                                    footer={footer}
                                    count={count}
                                    records={count}
                                    showIsEdit={canEdit && (props?.user?.id === 1 || props?.user?.role === 'hr')}
                                    showIsView={true}
                                    isDownloadSalarySlip={true}
                                    loading={props?.loading}
                                />
                            )
                        }
                    </div>
                </div>
            </div>

            <Modal
                show={showSalaryModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="custom-modal"
                onHide={closeSalaryModal}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className='heading'>Add Salary</h5>
                        <button className="btn-close" onClick={closeSalaryModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className='add-department-container'>
                            <div className='add-information-part'>
                                <div className='form-part'>
                                    <form>
                                        <div className="form-group">
                                            <div className='row'>
                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="input-css"
                                                            name='holdername'
                                                            placeholder='Add Salary Amount'
                                                            value={salaryAmount}
                                                            onChange={(e) => setSalaryAmount(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-end">
                        <button className="btn-cancel" onClick={closeSalaryModal}>
                            Cancel
                        </button>
                        <button className="btn-save" onClick={() => closeSalaryModal()}>
                            {props?.loading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Add"}
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                show={showModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="custom-modal"
                onHide={closeModal}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className='heading'>{bankDetails?.length > 0 ? "Update" : "Add"} Bank Details</h5>
                        <button className="btn-close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className='add-department-container'>
                            <div className='add-information-part'>
                                <div className='form-part'>
                                    <form>
                                        <div className="form-group">
                                            <div className='row'>
                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="input-css"
                                                            name='holdername'
                                                            placeholder='Holder Name As Per Bank'
                                                            value={acc_holder_name}
                                                            onChange={(e) => setAccountHolderName(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="input-css"
                                                            name='accountno'
                                                            placeholder='Bank Account Number'
                                                            value={account_number}
                                                            onChange={(e) => setAccountNumber(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="input-css"
                                                            name='bankname'
                                                            placeholder='Bank Name'
                                                            value={bank_name}
                                                            onChange={(e) => setBankName(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="input-css"
                                                            name='branchname'
                                                            placeholder='Branch Name'
                                                            value={branch_name}
                                                            onChange={(e) => setBranchName(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="input-css"
                                                            name='ifsccode'
                                                            placeholder='IFSC Code'
                                                            value={ifsc_code}
                                                            onChange={(e) => setIfscCode(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-end">
                        <button className="btn-cancel" onClick={closeModal}>
                            Cancel
                        </button>
                        <button className="btn-save" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.salaryReducer.loading,
        bankdetails: state.bankdetailsReducer.bankdetails,
        modules: state.authenticationReducer.modules,
        features: state.authenticationReducer.features,
        user: state.authenticationReducer.user,
        users: state.userReducer.users,
        salary: state.salaryReducer.salary,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getBankdetails: () => {
            dispatch(getBankdetails())
        },
        addBankdetails: (data) => {
            dispatch(addBankdetails(data))
        },
        updateBankdetails: (id, data) => {
            dispatch(updateBankdetails(id, data))
        },
        getUsers: (options) => {
            dispatch(getUsers(options))
        },
        getSalaryDetails: () => {
            dispatch(getSalaryDetails())
        },
        updateSalarySlip: (id, data) => {
            dispatch(updateSalarySlip(id, data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpSalarySlips)